
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./app.ts"
import * as amdModule1 from "./config/environment.ts"
import * as amdModule2 from "./initializers/ajax.ts"
import * as amdModule3 from "./initializers/error-handler.ts"
import * as amdModule4 from "./initializers/theme.ts"
import * as amdModule5 from "./instance-initializers/ember-intl.ts"
import * as amdModule6 from "./router.ts"
import * as amdModule7 from "./services/intl.ts"
import * as amdModule8 from "./services/meta.ts"
import * as amdModule9 from "./services/theme.ts"
import * as amdModule10 from "./utils/schema-org.ts"
import * as amdModule11 from "./instance-initializers/load-translations.js"
import * as amdModule12 from "./services/page-title.js"
import * as amdModule13 from "./initializers/ember-data.js"
import * as amdModule14 from "./services/store.js"
import * as amdModule15 from "./transforms/date.js"
import * as amdModule16 from "./transforms/number.js"
import * as amdModule17 from "./transforms/string.js"
import * as amdModule18 from "./transforms/boolean.js"
import * as amdModule19 from "./data-adapter.js"
import * as amdModule20 from "./templates/about.gts"
import * as amdModule21 from "./controllers/about.ts"
import * as amdModule22 from "./routes/about.ts"
import * as amdModule23 from "./templates/application.gts"
import * as amdModule24 from "./controllers/application.ts"
import * as amdModule25 from "./routes/application.ts"
import * as amdModule26 from "./templates/index.gts"
import * as amdModule27 from "./controllers/index.ts"
import * as amdModule28 from "./routes/index.ts"
import * as amdModule29 from "./templates/error.gts"
import * as amdModule30 from "./routes/error.ts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"marcemira/app": amdModule0,
"marcemira/config/environment": amdModule1,
"marcemira/initializers/ajax": amdModule2,
"marcemira/initializers/error-handler": amdModule3,
"marcemira/initializers/theme": amdModule4,
"marcemira/instance-initializers/ember-intl": amdModule5,
"marcemira/router": amdModule6,
"marcemira/services/intl": amdModule7,
"marcemira/services/meta": amdModule8,
"marcemira/services/theme": amdModule9,
"marcemira/utils/schema-org": amdModule10,
"marcemira/instance-initializers/load-translations": amdModule11,
"marcemira/services/page-title": amdModule12,
"marcemira/initializers/ember-data": amdModule13,
"marcemira/services/store": amdModule14,
"marcemira/transforms/date": amdModule15,
"marcemira/transforms/number": amdModule16,
"marcemira/transforms/string": amdModule17,
"marcemira/transforms/boolean": amdModule18,
"marcemira/data-adapter": amdModule19,
"marcemira/templates/about": amdModule20,
"marcemira/controllers/about": amdModule21,
"marcemira/routes/about": amdModule22,
"marcemira/templates/application": amdModule23,
"marcemira/controllers/application": amdModule24,
"marcemira/routes/application": amdModule25,
"marcemira/templates/index": amdModule26,
"marcemira/controllers/index": amdModule27,
"marcemira/routes/index": amdModule28,
"marcemira/templates/error": amdModule29,
"marcemira/routes/error": amdModule30,
  },
  exportFastbootModules
);
